module.exports = __webpack_public_path__ + "img/oldThreeFalse.12951e84.png";